/*
 * SidebarLink
 * @module Sidebar
 * @flow
 */

import React from 'react';
import { palette } from 'styled-theme';
import { ifNotProp } from 'styled-tools';
import styled, { css } from 'styled-components/macro';

const textColor = palette('primary', 3, true);

export type SidebarLinkProps = {|
  href: string,
  children: React$Node,
  icon?: React$Node,
  open?: boolean,
|};

const SidebarLinkElement = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 150px;
  height: 32px;
  min-height: 32px;
  margin: 24px auto 8px;
  background-color: #fff;
  border-radius: 20px;

  ${ifNotProp(
    'open',
    css`
      width: 32px;
    `,
  )}
`;

const SidebarLinkText = styled.span`
  flex: auto 0 0;
  margin-left: 8px;
  color: ${textColor};
  font-weight: bold;
  font-size: 12px;
  line-height: 2;
  text-transform: uppercase;
`;

/**
 * SidebarLink React-component
 * @memberof Sidebar
 * @param {boolean} [props.open] - sidebar open state
 * @param {Function} [props.href] - link for <a> tag
 * @example <caption>Simple usage</caption>
 * <SidebarLink icon={<IconWallet />}>My Wealth</SidebarItem>
 * @returns {React.Node<*>} React-component
 */
export const SidebarLink = ({
  href,
  icon,
  open,
  children,
  ...rest
}: SidebarLinkProps) => (
  <SidebarLinkElement open={open} href={href} {...rest}>
    <span>{icon}</span>
    {open && <SidebarLinkText>{children}</SidebarLinkText>}
  </SidebarLinkElement>
);
